var render = function (_h,_vm) {var _c=_vm._c;return _c('h2',{staticClass:"title",class:{'black' : _vm.props.blackText}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }